import leezenApplicationManagementReducer from "./leezenApplicationManagementReducer";

const leezenApplicationManagementReducers = {
    leezenApplicationManagement: leezenApplicationManagementReducer,
}

export default leezenApplicationManagementReducers;